import { createFileRoute } from '@tanstack/react-router';

import { PairingGamePageWidget } from '@features/game/pages/PairingGamePage/PairingGamePageWidget';

export const Route = createFileRoute('/game/pairing/$gameId')({
  component: Page,
});

function Page() {
  const { gameId } = Route.useParams();
  return <PairingGamePageWidget key={gameId} gameId={gameId} />;
}
